module.exports = __webpack_public_path__ + "img/32.acb7b1cc.jpg";